import { render, staticRenderFns } from "./SrDropzoneUploadFileList.vue?vue&type=template&id=084f9156"
import script from "./SrDropzoneUploadFileList.vue?vue&type=script&lang=js"
export * from "./SrDropzoneUploadFileList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports